<ng-container *ngIf="flowCompleted">
    <ridango-ticket
        *ngFor="let ticket of tickets"
        [locale]="locale"
        [ticket]="ticket"
        [hasZoneModal]="hasZoneModal"
        [assetsPath]="assetsPath$ | async"
        [cards]="relatedCardsNormalized$ | async"
        (requestRemoveCard)="removeCard($event)"></ridango-ticket>
</ng-container>
<div class="block--wrap block" *ngIf="flowCompleted">
    <div class="summary-module-area">
        <div class="summary-module-area__btn">
            <button class="btn btn--maximal btn--primary" (click)="postToCart()">
                {{ 'BUTTON_PROCEED_TO_PAYMENT' | translate }}
            </button>
        </div>
    </div>
</div>

<!-- unfinished selections -->
<div class="block--wrap block" *ngIf="!flowCompleted">
    <div class="empty-module-area">
        <p class="description">
            {{ 'TICKET_SUMMARY_PLEASE_FILL_DATA' | translate }}
        </p>
    </div>
</div>
